var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.625C3.39453 0.625 0.5 3.54492 0.5 7.125C0.5 10.7305 3.39453 13.625 7 13.625C10.5801 13.625 13.5 10.7305 13.5 7.125C13.5 3.54492 10.5801 0.625 7 0.625ZM6.39062 4.48438C6.39062 4.1543 6.64453 3.875 7 3.875C7.33008 3.875 7.60938 4.1543 7.60938 4.48438V7.73438C7.60938 8.08984 7.33008 8.34375 7 8.34375C6.64453 8.34375 6.39062 8.08984 6.39062 7.73438V4.48438ZM7 10.7812C6.54297 10.7812 6.1875 10.4258 6.1875 9.99414C6.1875 9.5625 6.54297 9.20703 7 9.20703C7.43164 9.20703 7.78711 9.5625 7.78711 9.99414C7.78711 10.4258 7.43164 10.7812 7 10.7812Z",
    fill: "#FF6347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.964f811e82f44f9187b076c4b40af0e9.svg";
export { ForwardRef as ReactComponent };